import type { IconCode } from "@ui-kit/Icon";

export const isImageAttachment = (attachment: { mime: string }) => attachment.mime.startsWith("image/");

export const getAttachmentIcon = (mime: string): IconCode => {
	if (mime.startsWith("image/")) return "image";
	if (mime.startsWith("audio/")) return "file-audio";
	if (mime.startsWith("video/")) return "file-video";
	return "file-text";
};
